import { OfferType } from '@model/offers/offers';
import { OfferTile } from './OfferTile';
import { getCMSOffers } from '@state/cms';
import { useSelector } from 'react-redux';
import { Entry } from '@model/contentful';
import { CMSOffer } from '@model/contentful/offers';
import { getDestination } from '@state/app';

export interface OfferTileContainerProps {
  offerType: OfferType;
}

export const OfferTileContainer = ({ offerType }: OfferTileContainerProps) => {
  const { components } = useSelector(getCMSOffers);
  const path = useSelector(getDestination);
  const offer: Entry<CMSOffer> = components.find((offerItem: Entry<CMSOffer>) => offerItem.fields.pageId === offerType);

  if (!offer) {
    return null;
  }

  return (
    <OfferTile
      icon={offer.fields.icon!}
      title={offer.fields.title}
      description={offer.fields.shortDescription}
      offerType={offer.fields.pageId as OfferType}
      path={path}
    />
  );
};
